import axios from "axios";

const API_DOMAIN = process.env.REACT_APP_TPOC_API_DOMAIN;

/**
 * Fetches access token using authCode.
 * @param {string} authCode
 * @returns {Promise<string|null>} accessToken
 */
export const getAccessToken = async authCode => {
    const url = `${API_DOMAIN}/api/token`;
    try {
        const response = await axios.post(
            url,
            { authCode },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        if (response.status === 200) {
            return response.data.access_token;
        } else {
            throw new Error(`Unexpected status: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching token:", error);
        throw error;
    }
};

/**
 * Fetches access token using authCode.
 * @param {string} authCode
 * @returns {Promise<string|null>} accessToken
 */
export const getServiceAccessToken = async authCode => {
    const url = `${API_DOMAIN}/api/token/service-account`;
    try {
        const response = await axios.post(
            url,
            { authCode },
            {
                headers: { "Content-Type": "application/json" }
            }
        );

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Unexpected status: ${response.status}`);
        }
    } catch (error) {
        console.error("Error fetching token:", error);
        throw error;
    }
};
